"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPageProductionOrder = void 0;
var _react = _interopRequireDefault(require("react"));
var _DmsPage = require("../../components/DmsPage/DmsPage");
var _DmsProductionOrderTable = require("../../components/DmsProductionOrder/DmsProductionOrderTable");
var _DmsAltBox = require("../../components/DmsAltBox/DmsAltBox");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsPageProductionOrder component renders the production order table.
 * Renders a DmsPage layout with a DmsAltBox containing the DmsProductionOrderTable component.
 * @component
 * @example
 * return (
 *   <DmsPageProductionOrder />
 * )
 */

const DmsPageProductionOrder = () => {
  return /*#__PURE__*/_react.default.createElement(_DmsPage.DmsPage, {
    name: "DmsProductionOrder"
  }, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h3",
    sx: {
      fontSize: '1.1rem'
    }
  }, _reactIntlUniversal.default.get("ProductionOrder").d("Production order"))), /*#__PURE__*/_react.default.createElement(_DmsAltBox.DmsAltBox.Body, null, /*#__PURE__*/_react.default.createElement(_DmsProductionOrderTable.DmsProductionOrderTable, null))));
};
exports.DmsPageProductionOrder = DmsPageProductionOrder;